<template> 
    <button :class="color" :disabled="disabled" @click="callback">{{text}}</button>
</template>
<script>
export default {
    props: ['text', 'color','callback', 'disabled']
}

</script>
<style scoped>
button{
    padding: 13px 24px 15px;
    width: 100%;
    height: 48px;
    background: #fff;
    border-radius: 8px;
    margin: 16px auto;
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 120%;
    align-items: center;
    text-align: center;
    color: #2B2D33;
    border: 1px solid #4B5EFF;
    display: block;
    transition: .5s;
}
button:focus-visible{
    outline: none;
    border: 2px solid #4B5EFF;
}
button:hover {
    cursor: pointer;
    border-color: #4B5EFF;
    background: #F3F4FF;
    transition: .5s;
}
.yellow{
    background: #FEE600;
    transition: .5s;
}
.yellow:hover{
    cursor: pointer;
    background: #FED500;
    transition: .5s
}
.blue-custom {
  background: #4B5EFF;
  border-color: #4B5EFF;
  color: #fff;
}
.blue-custom:hover {
  background: #3c4bcc;
  border-color: #3c4bcc;
}
</style>